<template>
  <div  :class="`d-flex justify-space-around`">
    <v-spacer></v-spacer>
    <v-text-field
      v-model="ac"
      outlined
      dense
      required
      prepend-inner-icon="mdi-lock-question"
      placeholder="Access code"
      :rules="acRules"
      hint="Your access code"
      :append-icon="eyevalueac ? 'mdi-eye' : 'mdi-eye-off'"
      @click:append="() => (eyevalueac = !eyevalueac)"
      @input="ac_changed"
      :type="eyevalueac ? 'password' : 'text'"
    ></v-text-field>
    <v-spacer></v-spacer>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "Ac",
  // regid: Number,
  data() {
    return {
      ac: String,
      eyevalueac: true,
      acRules: [(v) => !!v || "Access code is required"],
    //   model: null
    };
  },
  created() {
    this.ac = null;
  },
  methods: {
    clear() {
      this.model = null;
      this.$emit("ac_changed", this.ac);
    },
    ac_changed() {
    //   this.model = null;
      this.$emit("ac_changed", this.ac);
    }
  }
};
</script>